import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  getSportSessions,
  saveSportSession as localSaveSportSession,
  deleteSportSession as localDeleteSportSession,
  toggleSportSession as localToggleSportSession,
} from '../utils/scheduleData';
import {
  fsGetAllSportSessions,
  fsSaveSportSession,
  fsDeleteSportSession,
  fsToggleSportSession,
} from '../services/firestoreDb';

export function useSports() {
  const { user } = useAuth();
  const uid = user?.id;

  const [sessions, setSessions] = useState(() => getSportSessions());

  useEffect(() => {
    if (!uid) return;
    fsGetAllSportSessions(uid)
      .then((data) => {
        if (data !== null) setSessions(data);
      })
      .catch(() => {});
  }, [uid]);

  const upcoming = sessions
    .filter((s) => s.date >= new Date().toISOString().split('T')[0])
    .sort((a, b) => a.date.localeCompare(b.date));

  const saveSportSession = useCallback(
    async (sessionData) => {
      const entry = localSaveSportSession(sessionData);
      setSessions(getSportSessions());
      if (uid) {
        await fsSaveSportSession(uid, entry).catch(() => {});
      }
      return entry;
    },
    [uid]
  );

  const deleteSportSession = useCallback(
    async (id) => {
      localDeleteSportSession(id);
      setSessions(getSportSessions());
      if (uid) {
        await fsDeleteSportSession(uid, id).catch(() => {});
      }
    },
    [uid]
  );

  const toggleSportSession = useCallback(
    async (id) => {
      localToggleSportSession(id);
      setSessions((prev) =>
        prev.map((s) => (s.id === id ? { ...s, completed: !s.completed } : s))
      );
      if (uid) {
        await fsToggleSportSession(uid, id).catch(() => {});
      }
    },
    [uid]
  );

  return { sessions, upcoming, saveSportSession, deleteSportSession, toggleSportSession };
}
